import { HttpClient } from "@angular/common/http";
import { UrlServidor } from "../util/url-servidor";
import { Injectable } from "@angular/core";
import { Observable, of, tap } from "rxjs";
import { DanfeCstOrigem } from "../api/dto/danfe/danfe-cst-origem";
import { CacheService } from "./cache/cache.service";

@Injectable({
    providedIn: 'root',
})
export class DanfeCstOrigemService {
    constructor(private http: HttpClient, private cacheService: CacheService<DanfeCstOrigem[]>) { }

    private url : string = UrlServidor.URL_BASE + 'danfe-cst-origem';
    private cacheKey = 'danfe-cst-origem';
    private expiration = 240 * 60 * 1000;

    listar(): Observable<DanfeCstOrigem[]>{
        const cachedData = this.cacheService.get(this.cacheKey);

        if (cachedData) {
            return of(cachedData);
        } else {
            return this.http.get<DanfeCstOrigem[]>(this.url)
            .pipe(
                tap(response => this.cacheService.set(this.cacheKey, response, this.expiration))
              );
        }
    }
}